import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Flame, Grid3x3, MessageCircle, User } from "lucide-react";

const items = [
    { to: "/discover", icon: Flame, label: "Swipe", testid: "nav-discover" },
    { to: "/grid", icon: Grid3x3, label: "Grid", testid: "nav-grid" },
    { to: "/matches", icon: MessageCircle, label: "Matches", testid: "nav-matches" },
    { to: "/profile", icon: User, label: "Profile", testid: "nav-profile" },
];

export default function BottomNav() {
    const { pathname } = useLocation();
    // Hide on chat pages
    if (pathname.startsWith("/chat/")) return null;
    return (
        <nav
            className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50 border-t border-white/10 backdrop-blur-xl bg-black/85"
            data-testid="bottom-nav"
        >
            <div className="grid grid-cols-4">
                {items.map(({ to, icon: Icon, label, testid }) => (
                    <NavLink
                        key={to}
                        to={to}
                        data-testid={testid}
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center gap-0.5 py-3 text-[11px] uppercase tracking-widest transition-colors ${
                                isActive ? "text-smash" : "text-white/50 hover:text-white"
                            }`
                        }
                    >
                        <Icon className="w-5 h-5" strokeWidth={2.25} />
                        <span className="font-display">{label}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
